import moment from 'moment';

const hasAvailability = (date, expert, client) => {
  let retval = false;
  expert.forEach(e => {
    client.forEach(c => {
      if (moment(date).format('DDMMYYYY') === moment(e.time.start).format('DDMMYYYY') || moment(date).format('DDMMYYYY') === moment(c.time.start).format('DDMMYYYY')) {
        const eStart = e.time.start;
        const eEnd = e.time.end;
        const cStart = c.time.start;
        const cEnd = c.time.end;

        if (Math.max(cEnd, eEnd) - Math.min(cStart, eStart) < eEnd - eStart + (cEnd - cStart)) {
          retval = true;
        }
      }
    });
  });
  return retval;
};

export default hasAvailability;